import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const trilhaFormativaRoutes: Routes = [
  {
    path: 'trilha-formativa',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Trilha Formativa',
      breadcrumb: [{ label: 'Trilha Formativa' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./trilha-formativa.component').then((m) => m.TrilhaFormativaComponent),
        data: {
          title: 'Trilha Formativa',
          roles: [Role.TRILHA_FORMATIVA_VISUALIZAR_PROFISSIONAL],
          breadcrumb: [{ label: 'Trilha Formativa', url: '/trilha-formativa' }],
        },
      },
      {
        path: 'administracao/participantes',
        loadComponent: () =>
          import('./cgfip/participantes-cgfip/participantes-cgfip.component').then(
            (m) => m.ParticipantesCgfipComponent
          ),
        data: {
          title: 'Participantes dos Programas',
          roles: [Role.PARTICIPANTE_VISUALIZAR_ADMINISTRACAO],
          breadcrumb: [
            { label: 'Trilha Formativa', url: '/trilha-formativa' },
            { label: 'Participantes dos Programas', url: '/trilha-formativa/administracao/participantes' },
          ],
        },
      },
      {
        path: 'administracao/participantes/:cpf',
        loadComponent: () =>
          import('./cgfip/perfil-cgfip/perfil-cgfip.component').then((m) => m.PerfilCgfipComponent),
        data: {
          title: 'Perfil do Profissional',
          roles: [Role.PARTICIPANTE_VISUALIZAR_ADMINISTRACAO],
          breadcrumb: [
            { label: 'Trilha Formativa', url: '/trilha-formativa' },
            { label: 'Participantes dos Programas', url: '/trilha-formativa/administracao/participantes' },
            { label: 'Perfil do Profissional' },
          ],
        },
      },
    ],
  },
];




